import { render, staticRenderFns } from "./liveCard.vue?vue&type=template&id=71c49342&scoped=true&"
import script from "./liveCard.vue?vue&type=script&lang=js&"
export * from "./liveCard.vue?vue&type=script&lang=js&"
import style0 from "./liveCard.vue?vue&type=style&index=0&id=71c49342&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c49342",
  null
  
)

export default component.exports